export default "__VITE_ASSET___$dZHlXz__"